import {
    Avatar,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Pagination,
    Paper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from "@mui/material"
import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import api from "../../services/api"
import { makeStyles } from "@mui/styles"
import { green } from "@mui/material/colors"

const useStyles = makeStyles((theme) => ({
    mainPaper: {
        flex: 1,
        padding: theme.spacing(1),
        overflowY: "scroll",
        ...theme.scrollbarStyles,
    },
    header: {
        textAlign: "center",
        padding: theme.spacing(2),
    },
}))

function LeadsSelectorModal({ isOpen, onClose, onImport }) {
    const classes = useStyles()
    const [leads, setLeads] = useState([])

    const [page, setPage] = useState(1)
    const [pageSize] = useState(10)
    const [count, setCount] = useState(0)
    const [loading, setLoading] = useState(false)

    const [selectAll, setSelectAll] = useState(false)
    const [selected, setSelected] = useState([])

    async function getData() {
        try {
            const { data } = await api.get("/leads", {
                params: { page, pageSize },
            })

            setLeads(data.leads)
            setCount(data.total)
        } catch (error) {
            toast.error("Erro ao buscar leads")
        }
    }

    const handlePageChange = (event, value) => {
        setPage(value)
    }

    useEffect(() => {
        setLoading(true)
        const delayDebounceFn = setTimeout(() => {
            getData()
        }, 500)
        return () => clearTimeout(delayDebounceFn)
    }, [page])

    const handleChangeSelectId = (id) => {
        if (selectAll) return

        if (selected.includes(id)) {
            setSelected(selected.filter((item) => item !== id))
        } else {
            const arr = [...selected]
            arr.push(id)
            setSelected(arr)
        }
    }

    const handleClose = () => {
        setSelectAll(false)
        setSelected([])
        onClose()
    }

    return (
        <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth="md">
            <DialogTitle>Selecionar Leads</DialogTitle>
            <DialogContent>
                <Paper className={classes.mainPaper} variant="outlined">
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell align="left"></TableCell>
                                <TableCell align="left">Nome</TableCell>
                                <TableCell align="center">Telefone</TableCell>
                                <TableCell align="center">E-mail</TableCell>
                                <TableCell align="center">
                                    <input
                                        type="checkbox"
                                        id="select-all"
                                        style={{ cursor: "pointer" }}
                                        checked={selectAll}
                                        onChange={() =>
                                            setSelectAll(!selectAll)
                                        }
                                    />
                                    <label
                                        htmlFor="select-all"
                                        style={{ cursor: "pointer" }}
                                    >
                                        Todos
                                    </label>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {leads.map((lead) => (
                                <TableRow
                                    key={lead?.id}
                                    sx={{
                                        backgroundColor:
                                            lead.viwed === false
                                                ? green[100]
                                                : "inherit",
                                    }}
                                >
                                    <TableCell align="left">
                                        <Avatar
                                            sx={{ width: 24, height: 24 }}
                                            src={lead?.contact.profilePicUrl}
                                        />
                                    </TableCell>
                                    <TableCell align="left">
                                        {lead?.name}
                                    </TableCell>
                                    <TableCell align="center">
                                        {lead?.contact.number}
                                    </TableCell>
                                    <TableCell align="center">
                                        {lead?.contact.email}
                                    </TableCell>
                                    <TableCell align="center">
                                        <input
                                            type="checkbox"
                                            checked={
                                                selectAll ||
                                                selected.includes(
                                                    lead.contact.id,
                                                )
                                            }
                                            onChange={() =>
                                                handleChangeSelectId(
                                                    lead.contact.id,
                                                )
                                            }
                                            style={{
                                                cursor: "pointer",
                                                padding: 6,
                                            }}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                    <Stack spacing={2} sx={{ mt: 2, alignItems: "center" }}>
                        <Pagination
                            count={Math.ceil(count / pageSize)}
                            page={page}
                            onChange={handlePageChange}
                            color="primary"
                        />
                    </Stack>
                </Paper>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleClose}
                >
                    Cancelar
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        onImport({ selected, selectAll, type: "leads" })
                        handleClose()
                    }}
                >
                    Importar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default LeadsSelectorModal
